import React, { useEffect } from "react";
import AuthTree from "./tree/AuthTree";
import AuthDefault from "./AuthDefault";
import { useSelector, useDispatch } from "react-redux";
import CreatePage from "./createModal/CreatePage";
import DetailedPage from "./DetailedPage";
import { isEmptyJsonObject } from "../common/utils/helper";
import { saveCred, discardCred, deleteCred } from "../redux/actions/credActions";
import {useSaveShortcut} from "../common/utils/keybindings"

const AuthPage = () => {
  const selectedCred = useSelector((state) => state.auth.selectedCred);
  const unsaved_cred = useSelector((state) => state.auth.unsaved_cred);
  const dispatch = useDispatch();

  const doSave=()=>{
    if(unsaved_cred){
      dispatch(saveCred(selectedCred))
    }
  }
  useSaveShortcut(doSave)
  
  

  return (
    <div className="ihub-main-view">
      <div className="ihub-credentials-bar">
        <h3>Credentials</h3>
        <CreatePage />
      </div>

      <div className="ihub-flexbox">
        <div className="ihub-flex1">
          <AuthTree />
        </div>
        <div className="ihub-flex3 ihub-auth-panel">
          <div className="credential-settings-wrapper">{isEmptyJsonObject(selectedCred) ? <AuthDefault /> : <DetailedPage />}</div>
        </div>
      </div>
    </div>
  );
};
export default AuthPage;
